import { dateToApiFormat } from '@/helpers/dateHelper';
import { useSaveMySchedule } from '@/services/availability/useSaveMySchedule';
import { EmployeeSchedule } from '@/services/employee/schedule/schedule.types';
import { useMySchedule } from '@/services/employee/schedule/useMySchedule';
import { FC } from 'react';
import { MyAvailabilityForm } from './MyAvailabilityForm';

interface MyAvailabilityContentProps {
  date: Date;
  onSaved: () => void;
  onCancel: () => void;
}

export const MyAvailabilityContent: FC<MyAvailabilityContentProps> = ({ date, onSaved, onCancel }) => {
  const data = useMySchedule(date);
  const { save, fetching } = useSaveMySchedule(date, date);

  const dateKey = dateToApiFormat(date);

  const onSave = async (payload: EmployeeSchedule) => {
    const success = await save(payload);
    if (success) {
      onSaved();
    }
  };

  return (
    <MyAvailabilityForm
      date={date}
      existingDay={data.schedule[dateKey]}
      fetching={fetching}
      onSave={onSave}
      onCancel={onCancel}
    />
  );
};
